/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICusPromoBannerProps } from './cus-promo-banner.props.autogenerated';
import * as React from 'react';

export interface ICusPromoBannerViewProps extends ICusPromoBannerProps<unknown> {}

export default function CusPromoBanner(props: ICusPromoBannerProps<unknown>): JSX.Element | null {
    const texts = Array.from(props.config.textList?.values?.() ?? []);
    const repeatedTexts: string[] = Array(3).fill(texts).flat();

    // Two identical groups: scrolling the track by one group width loops without a gap.
    return (
        <div className='bs-promo-banner'>
            <div className='bs-promo-banner__track'>
                {[false, true].map(isDuplicate => (
                    <div className='bs-promo-banner__group' key={String(isDuplicate)} aria-hidden={isDuplicate}>
                        {repeatedTexts.map((text, index) => (
                            <div className='bs-promo-banner__item' key={index}>
                                {text}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
